import { generateColorScheme } from "../../src/utils/colors";

export const neutral = {
    white: '#FFFFFF',
    black: '#000000',
    50: '#FBFBFC',
    ...generateColorScheme('#AAB1BE'),
};
